/* tslint:disable:max-line-length */
/// <reference path='../../core/services/resource.service.ts'/>

namespace Search {

    class IntegratedSearchTab {
        constructor(
            public searchType: UnifiedSearchType,
            public tabPanel: string,
            public titleResource: string,
            public icons: string[]
        ){
        }
        isVisible: boolean;
        href: string;
    }

    class IntegratedSearch {

        // Attr
        includedTabs: UnifiedSearchType[];
        preselectTab: string;
        hiddenQueryString: string;
        fid: string;
        trackDefaultParameters: string;
        clearFormInAgentMode: string;
        overrideAllowNoDatesYet: string;
        isFlexibleTripType: boolean;
        disableResetOptions;

        // Private
        tabs: IntegratedSearchTab[] = [];
        searchType: UnifiedSearchType;
        tabPanel: string;

        constructor (
            private $route: ng.route.IRouteService,
            private $scope,
            private $q,
            private searchUnitService: SearchUnitService
        ) {

            this.prepareTabs();
            // select the initial tab
            $q.when(
                this.preselectTab
                ? parseInt(this.preselectTab, 10) as UnifiedSearchType
                : this.searchUnitService.getLastSearchType()
            ).then(result => {
                this.searchType = result || UnifiedSearchType.Holidays; // todo: this should use a "default search type" config setting
                this.tabPanel = this.getTabPanel(this.searchType);
                //select the first supported tab by default;
                if (!this.tabPanel) {
                    this.searchType = this.tabs[0].searchType;
                    this.tabPanel = this.getTabPanel(this.searchType);
                }
            });

            if(!TRPCONFIG.Domain.NoDatesYetEnabled) {
                this.overrideAllowNoDatesYet = 'false';
            }
        };

        getClearForm() {
            return !!(TRPCONFIG.Domain.isAgentMode && this.clearFormInAgentMode === 'true');
        }

        selectTab(tab: IntegratedSearchTab): void {
            if (!tab.href) {
                this.searchType = tab.searchType;
                this.tabPanel = tab.tabPanel;
            }
        };

        prepareTabs(): void {
            let push = tab => {
                let isSupported = _.filter(TRPCONFIG.Domain.SupportedProductNames, t => t === UnifiedSearchType[tab.searchType]).length;
                if (isSupported) {
                    tab.isVisible = !this.includedTabs || this.includedTabs.indexOf(tab.searchType) > -1;
                    this.tabs.push(tab);
                }
            };

            push(new IntegratedSearchTab(UnifiedSearchType.Holidays, 'unified', 'SEARCHUNITTITLEHOLIDAYS', ['flights', 'hotels']));
            push(new IntegratedSearchTab(UnifiedSearchType.HolidayDeals, 'holidaydeals', 'MENUDEALS', ['sun']));
            push(new IntegratedSearchTab(UnifiedSearchType.Hotels, 'unified', 'SEARCHUNITTITLEHOTELS', ['hotels']));
            push(new IntegratedSearchTab(UnifiedSearchType.Flights, 'unified', 'SEARCHUNITTITLEFLIGHTS', ['flights']));
            push(new IntegratedSearchTab(UnifiedSearchType.Transfers, 'transfers', 'SEARCHUNITTITLETRANSFERS', ['transfers']));
            let cruiseTab = new IntegratedSearchTab(UnifiedSearchType.Cruises, 'cruises', 'SEARCHUNITTITLECRUISES', ['cruise']);
            cruiseTab.href = `${TRPCONFIG.Domain.CruiseRootUrl}/?utm_source=Cruise%20Button&utm_medium=TR%20Homepage&utm_campaign=Travel%20Republic%20Cruise%20Button`;
            push(cruiseTab);
            push(new IntegratedSearchTab(UnifiedSearchType.Marhaba, 'marhaba', 'MARHABA', ['marhaba-outline']));
            push(new IntegratedSearchTab(UnifiedSearchType.Insurance, 'insurance', 'INSURANCE', ['insurance']));
        }

        getTabPanel(searchType: UnifiedSearchType): string {
            let tab = _.find(this.tabs, { searchType: searchType });
            return tab && tab.tabPanel;
        }
    }

    angular
        .module('search')
        .directive('integratedSearch', (): ng.IDirective => {
            return {
                scope: {},
                controller: IntegratedSearch,
                controllerAs: 'is',
                bindToController: {
                    preselectTab: '@',
                    includedTabs: '=?',
                    hiddenQueryString: '@',
                    fid: '@',
                    trackDefaultParameters: '@',
                    clearFormInAgentMode: '@',
                    overrideAllowNoDatesYet: '@',
                    isFlexibleTripType: '=?',
                    disableResetOptions: '@?'
                },
                templateUrl: 'partials/search/integratedsearch',
                replace: true,
                restrict: 'E'
            };
        });
}
